import React, {memo} from 'react';
import Svg, {Path} from 'react-native-svg';
import {useLocale} from "@redlink/assets/locale";

export const IconArrowLeft = memo(
    ({color = '#545454', size = 24, ...rest}) => {
        const {isRtl} = useLocale();
        return (
            <Svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
                {isRtl ? <Path
                    fill={color}
                    fillRule="nonzero"
                    d="M15.41 16.58L10.83 12l4.58-4.59L14 6l-6 6 6 6z"
                /> : <Path
                    fill={color}
                    d="M7.41 10.58L2.83 6 7.41 1.41 6 0 0 6 6 12z"
                    transform="matrix(-1 0 0 1 16 6)"
                />}
            </Svg>
        );
    }
);
